import { render, staticRenderFns } from "./ResizableImageDialog.vue?vue&type=template&id=0d0c1bf3"
import script from "./ResizableImageDialog.vue?vue&type=script&lang=js"
export * from "./ResizableImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports